<template>
  <div>
    <div class="fixation-nav">
      <transition name="slide-fade">
        <div @click="show = !show" v-show="show" class="yingcang">
          隠す<i class="el-icon-caret-right"></i>
        </div>
      </transition>
      <transition name="slide-fade">
        <ul v-show="show">
          <li class="cart">
            <router-link to="/cart/hotboom">
              <span v-if="$store.state.cartCount != ''">{{
          $store.state.cartCount
        }}</span>
              <img src="../../assets/nav/nav1.png" alt />
              <img src="../../assets/nav/wckNav1.png" class="block" alt />
            </router-link>
          </li>
          <!-- <li>
            <a href="#">
              <img src="../../assets/nav/nav (1).png" alt />
              <img src="../../assets/nav/wckNav (4).png" class="block" alt />
            </a>
          </li>
          <li>
            <a href="#">
              <img src="../../assets/nav/nav (3).png" alt />
              <img src="../../assets/nav/wckNav (5).png" class="block" alt />
            </a>
          </li>
          <li>
            <router-link to="/calendar">
              <img src="../../assets/nav/nav (2).png" alt />
              <img src="../../assets/nav/wckNav (1).png" class="block" alt />
            </router-link>
          </li> -->
          <li>
            <router-link to="/user/index">
              <img src="../../assets/nav/wckNav (6).png" alt />
              <img src="../../assets/nav/wckNav (2).png" class="block" alt />
            </router-link>
          </li>
        </ul>
      </transition>
      <transition name="slide-fade">
        <div class="show" @click="show = !show" v-show="show == false">
          <i class="el-icon-caret-left"></i>
          <div class="border"></div>
          <span>
            展
            <br />開
          </span>
        </div>
      </transition>
    </div>
    <!-- 聊天 -->
    <div class="chatWork" @click="chat">
      <img src="../../assets/img/chatwork.png" alt="">
    </div>
    <!-- 返回 -->
    <el-backtop :bottom="age" :right="0" class="fanhui">
      <div>
        <img src="../../assets/nav/nav (5).png" alt />
        <img src="../../assets/nav/wckNav (3).png" class="block" alt />
      </div>
    </el-backtop>
  </div>
</template>
<script>
var page = document.body.clientHeight;
import { mapState } from 'vuex'
export default {
  data() {
    return {
      age: page / 6,
      show: true,

    };
  },
  computed: {
    // 登入状态
    ...mapState(["userInfo"]),
  },
  methods: {
    chat() {
      let url = 'https://www.chatwork.com/RAKUMART-CS'
      if (this.userInfo == null) {
        url = 'https://www.chatwork.com/RAKUMART-CS'
      } else {
        if (this.userInfo.chatwork_group) {
          url = ' https://www.chatwork.com/#!rid' + this.userInfo.chatwork_group
        }

      }
      window.open(url, ' _blank')
    },
  },
};
</script>
<style lang='scss' scoped>
.chatWork {
  height: 70px;
  // background-color: #fff;
  cursor: pointer;
  position: fixed;
  right: 0;
  bottom: 20%;

  img {
    height: 100%;
    border: 1px solid red;
    border-radius: 35px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12),
      0 0 6px rgba(0, 0, 0, .04);
  }
}

.fixation-nav {
  position: fixed;
  width: 60px;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  //   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  z-index: 999;

  .yingcang {
    height: 23px;
    background: #f3c622;
    color: #fff;
    line-height: 23px;
    margin-bottom: 10px;
    font-size: 14px;
    text-align: center;
    // width: 50px;
    // transform: translate(10px, 0);
    border-top-left-radius: 5px;
    cursor: pointer;
  }

  img {
    height: 62px;
    width: 60px;
  }

  ul {
    li {

      //   img {
      //     height: 62px;
      //     width: 60px;
      //   }
      &:hover .block {
        display: block;
      }

      a {
        position: relative;
        display: block;
        height: 62px;
        width: 60px;

        .block {
          position: absolute;
          top: 0;
          right: 0;
          display: none;
        }
      }
    }

    .cart {
      position: relative;

      span {
        position: absolute;
        top: 5px;
        right: 3px;
        font-size: 20px;
        color: #fff;
        width: 30px;
        height: 20px;
        background: #f3c622;
        text-align: center;
        line-height: 20px;
        border-radius: 50%;
        z-index: 99;
      }
    }
  }

  .show {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
    cursor: pointer;
    height: 80px;
    width: 40px;
    background: #f3c622;
    border-radius: 2px;
    border-top-left-radius: 30%;
    color: #fff;
    overflow: hidden;

    &:hover {
      background: #b1710d;
    }

    i {
      font-size: 25px;
      color: #fff;
      margin-left: 7px;
      margin-top: 5px;
    }

    .border {
      width: 30px;
      border-bottom: 1px solid #fff;
      margin: 0 auto;
    }

    span {
      display: block;
      text-align: center;
      font-size: 13px;
      margin-top: 6px;
    }
  }
}

.fanhui {
  width: 60px;
  height: 62px;
  background: transparent;
  border-radius: 0;

  img {
    height: 62px;
    width: 60px;
  }

  &:hover .block {
    display: block;
  }

  .block {
    position: absolute;
    top: -2px;
    left: 0;
    display: none;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
  {
  transform: translate(20px);
  opacity: 0;
}
</style>